import QuickshopOverlayModule from "./quickshop-overlay.module";

// !!! DO NOT REMOVE !!!
// imports are required for webpack build
import QuickshopOverlayComponent from "./quickshop-overlay.component";
import QuickshopOverlayDirective from "./quickshop-overlay.directive";

if(window.ceresStore)
{
    window.ceresStore.registerModule("cytQuickshopOverlay", QuickshopOverlayModule);
}
